export const EVENT_SOURCE_ID_PRIMARY = '29001';

/**
 * Method to Check if the Event is from a External Primary Event Source.
 * @param event [object={}] The Instance of the Event Object got from the Search Catalog Events API.
 * @returns boolean [boolean] The flag indicating if the event is from External Primary Event Source.
 * @TODO - This Method is used in the `react-event-redirection` and have to replaced there
 *
 */
export default (event = {}) => {
  const sourceId = event.attributes ? event.attributes.sourceId : event.sourceId;

  return sourceId === EVENT_SOURCE_ID_PRIMARY;
};
